<template>
    <ModalContainer id="registerModal">
        <section class="modal__content">
            <header class="modal__header">
                <h5 class="modal__title">{{ $t('words.wait_media_content_register') }}</h5>
                <p class="modal__desc upload-wait-media-desc" v-html="
                            $t('paragraphs.program_wait_file_upload_only_desc', {
                                maxWidth: mediaContents.meta.max_width,
                                maxHeight: mediaContents.meta.max_height
                            })"
                >
                </p>
                <button
                    aria-label="Close"
                    class="btn--icon btn--ghost modal__close"
                    data-dismiss="modal"
                    type="button">
                    <i
                        aria-hidden="true"
                        class="icon icon-close"/>
                </button>
            </header>
            <section class="modal__body">

                <DropToUploadContent
                    accept="image/png, image/jpeg"
                    @upload="handleUpload"
                />
                <ul :class="{'upload-list': true, 'max-height': uploadFiles.length >= 5}">
                    <UploadProgress
                        v-for="(uploadFile,i) in uploadFiles"
                        v-if="uploadFiles.length > 0"
                        :key="`uploadFile_${i}`"
                        :index="i"
                        :uploadFile="uploadFile"
                        @resendUploadFile="resendUploadFile"
                        @setRemoveUploadFile="setRemoveUploadFile"
                    />
                </ul>
                <SetTranscoding
                    waitMediaContent
                />
            </section>
            <section v-if="isHavingCompleteUploadFiles" class="modal__body success-clear">
                <button class="btn--icon btn--ghost none--hover" @click="handleCompleteClear">
                    <span class="none--hover-txt"> {{ $t('words.complete_upload_clear') }} </span>
                </button>
            </section>
        </section>
    </ModalContainer>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import DropToUploadContent from '@/components/cms/common/Modal/Upload/DropToUploadContent';
import SetTranscoding from '@/components/cms/common/Modal/Upload/SetTranscoding';
import UploadProgress from '@/components/cms/common/Modal/Upload/UploadProgress';
import ModalContainer from '@/components/cms/common/Modal/ModalContainer';

export default {
    name: 'UploadModal',
    components: {
        DropToUploadContent,
        SetTranscoding,
        UploadProgress,
        ModalContainer,
    },
    computed: {
        ...mapGetters('wait_media_contents', ['mediaContents']),
        ...mapGetters('wait_media_contents_upload', ['uploadFiles', 'generalUpload', 'totalProgress']),
        isHavingCompleteUploadFiles() {
            const filterUploadFiles = this.uploadFiles.filter(el => el.status === 'done' || el.status === 'fail' || el.status === 'cancel');
            return filterUploadFiles.length > 0;
        },
    },
    methods: {
        ...mapMutations({
            setClearCompleteUploadFiles: 'wait_media_contents_upload/setClearCompleteUploadFiles',
            setRemoveUploadFile: 'wait_media_contents_upload/setRemoveUploadFile',
        }),
        ...mapActions({
            postUploadFiles: 'wait_media_contents_upload/postUploadFiles',
            resendUploadFile: 'wait_media_contents_upload/resendUploadFile',
        }),
        handleUpload({ files, done }) {
            const maxUploadingCount = 20;
            const currentUploadingCount = this.uploadFiles.filter(el => el.status === 'uploading').length;
            const afterUploadingCount = currentUploadingCount + files.length;

            if (afterUploadingCount > maxUploadingCount) {
                this.$toasted.error(this.$t('words.max_uploading_count_message'));
                return;
            }
            try {
                if (files && files.length > 0) {
                    // FileList 는 Array 객체가 아님
                    const uploadFiles = Array.from(files); // FileList => Array 로 변환

                    this.postUploadFiles(uploadFiles);
                }
            } catch (e) {
                // console.log(e);
            } finally {
                done();
            }
        },
        isAllowFileMaxSize(fileSize) {
            const maxSize = 2 * 1024 * 1024 * 1024; // 2GB;
            return fileSize < maxSize;
        },
        handleCompleteClear() {
            this.setClearCompleteUploadFiles();
        },
        handleRemoveFile(file) {
            const index = this.uploadFiles.findIndex(file);
            this.uploadFiles.splice(index, 1);
        },
    },
};
</script>
